
import cartMixin from '@/mixins/cartMixin.js';
import addressMixin from '@/mixins/addressMixin.js';
import { mapState } from 'vuex';
export default {
  mixins: [cartMixin, addressMixin],
  name: 'CheckoutCustomerConnected',

  data() {
    return {
      addressesLoaded: false,
    };
  },

  computed: {
    ...mapState('checkout', [
      'shippingAddress',
      'shippingType',
      'checkoutCarrier',
      'checkoutRelayPoint',
      'invoiceAddress',
    ]),
    cartTotal() {
      return this.cart?.Total?.ToPay?.TaxIncl.toFixed(0);
    },
    isExpressCheckoutEnabled() {
      const flag = String(process.env.EXPRESS_CHECKOUT || 'enabled').toLowerCase();
      return !['0', 'false', 'off', 'disabled', 'no'].includes(flag);
    },
  },

  async created() {
    await this.addressService.fetchAddresses({
      onSuccess: () => {
        this.addressesLoaded = true;
      },
    });
  },
};
